import { useHashScroll } from "@/core/composable/useHashScroll";
import { useBus } from "@/core/store/bus";
import { useLayoutStore } from "@/stores/layout";
import { defineStore, storeToRefs } from "pinia";
import { ref, watch } from "vue";

const STORE_NAME = 'page-front'

export const usePageFrontStore = defineStore(STORE_NAME, () => {

    const layoutStore = useLayoutStore()

    const {headerHeight} = storeToRefs(layoutStore)
    
    const {bus} = useBus()

    const scrollNav = useHashScroll({
        find: true,
        scrollOffset: headerHeight,
    })

    const activeSection = ref<string | null>(null)

    const activeSectionStopUpdate = ref<boolean>(false)

    const setActiveSection = async (code: string) => {
        if (activeSectionStopUpdate.value)
            return;
        activeSectionStopUpdate.value = true
        activeSection.value = code
        
        // Отправляем событие для предзагрузки секции
        bus.emit('section:navigate', code)
        
        await scrollNav.scrollTo(activeSection.value)
        // Сбрасываем флаг после завершения скролла
        activeSectionStopUpdate.value = false
    }

    /**
     * Устанавливает активную секцию БЕЗ скролла
     * Используется для визуального обновления меню без навигации
     * Синхронизирует activeSection и activeHash
     */
    const setActiveSectionSilent = (code: string | null) => {
        // Устанавливаем activeSection
        activeSection.value = code
        
        // Синхронизируем activeHash БЕЗ скролла
        // Это важно для корректной работы MegaMenu
        scrollNav.updateHash(code, 'scroll')
    }

    watch(scrollNav.activeHash, (newHash) => {
        // Если идёт программный скролл (клик в меню) - игнорируем обновление от IntersectionObserver
        if (activeSectionStopUpdate.value) return
        console.log('[page-front] activeHash changed:', newHash)
        activeSection.value = newHash
    }, {immediate: true})

    return {
        setActiveSection,
        setActiveSectionSilent,
        activeSection,
        scrollNav
    }
})

